const o = "カラーフィールド、現在のカラーは{color}です", r = "Color field", l = "Colors palette", e = "プリセットカラー", t = "Custom preset colors", c = "Add color", s = "カラーをクリア", C = "Custom color, HEX format", d = "カスタムカラーリストに色を追加", n = "カスタムカラーフィールドをクリア", a = "Delete color with backspace", i = {
  currentColor: o,
  emptyColor: r,
  palette: l,
  presetColors: e,
  customColors: t,
  addColor: c,
  clearColor: s,
  colorField: C,
  colorFieldConfirm: d,
  colorFieldClear: n,
  deleteColorDescriber: a
};
export {
  c as addColor,
  s as clearColor,
  C as colorField,
  n as colorFieldClear,
  d as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  i as default,
  a as deleteColorDescriber,
  r as emptyColor,
  l as palette,
  e as presetColors
};
